import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppContext from "../../context/app/context";
import SkipReasonContext from "../../context/skip-reason/context";
import { useIsMount } from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";
import SkipReasonContextProvider from "../../context/skip-reason/provider";
import SkipReasonTable from "../../components/skip-reason/skip-reason-table";
import SkipReasonFilter from "../../components/skip-reason/skip-reason-filter";
import SearchFilterCard from "../../components/general/filter-card";
import Can from "../../utils/rbac/can";
import PageHeader from "../../components/general/layout/page-header";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import { Permissions } from "../../utils/Permissions/Permissions";

interface IProps {
  children?: React.ReactNode;
}

const SkipReasonComponent: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const { actions, loading, query } = useContext(SkipReasonContext);

  useEffect(() => {
    actions.setSearch(search);
  }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {
    !isMounted && actions.getData();
  }, [query, direction]);

  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("skip_reasons")}
        subTitle={t("skip_reasons_management")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Can key={2} perform={Permissions.CAN_CREATE_SKIP_REASON}>
            <Divider key={1} type="vertical" />
            <Button
              type="primary"
              onClick={() => {
                navigate(`/skip-reasons/create`);
              }}
              icon={<PlusOutlined />}
            >
              {t("add_skip_reason")}
            </Button>
          </Can>,
        ]}
      />
      <SearchFilterCard
        formId="skip-reason-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          actions.setQuery({
            page: query?.page,
            perPage: query?.perPage,
          });
          const form = document.getElementById("skip-reason-filter");
          if (form) {
            form.dispatchEvent(
              new Event("reset", { cancelable: true, bubbles: true })
            );
          }
        }}
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      >
        <SkipReasonFilter />
      </SearchFilterCard>

      <SkipReasonTable />
    </div>
  );
};

const SkipReasonPage = () => {
  return (
    <SkipReasonContextProvider>
      <SkipReasonComponent />
    </SkipReasonContextProvider>
  );
};

export default SkipReasonPage;
